import * as React from "react";
const SvgArrowLeftLongToLine = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M2 29.45L2 10.55C2 9.80189 2.60188 9.20001 3.35 9.20001C4.09813 9.20001 4.7 9.80189 4.7 10.55L4.7 29.45C4.7 30.1981 4.09812 30.8 3.35 30.8C2.60187 30.8 2 30.1981 2 29.45ZM9.59375 20.9563C9.065 20.4275 9.065 19.5725 9.59375 19.0494L17.2438 11.3938C17.7725 10.865 18.6275 10.865 19.1506 11.3938C19.6737 11.9225 19.6794 12.7775 19.1506 13.3006L13.8069 18.6444L36.65 18.65C37.3981 18.65 38 19.2519 38 20C38 20.7481 37.3981 21.35 36.65 21.35L13.8069 21.35L19.1506 26.6938C19.6794 27.2225 19.6794 28.0775 19.1506 28.6006C18.6219 29.1238 17.7669 29.1294 17.2437 28.6006L9.59375 20.9563Z" }));
export default SvgArrowLeftLongToLine;
